import { When } from "react-if";

import styles from "../index.module.less";

/**
 * @param {any} action
 * @param {any} children
 * @returns {any}
 */
export default function TabPanel({ actions, children }) {
  return (
    <div>
      <When condition={actions}>
        <div className={styles.actions}>{actions}</div>
      </When>
      {children}
    </div>
  );
}
